import { useCallback } from "react";
import Switch from "@coworker/apprestructured/src/task-management/components/Switch/Switch";
import { CreatorFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { useTranslation } from "@coworker/locales";
import LoadingCreatorFragment from "@coworker/apprestructured/src/task-management/components/LoadingCreatorFragment/LoadingCreatorFragment";
import { useTeamId, useUID } from "@coworker/app/src/core/auth/useLoggedInUser";
import { PatchTask } from "@coworker/apprestructured/src/task-management/types/Task";

export type MarkAsCompleteCreatorFragmentConfigProps = {
  autoAssignOnComplete?: boolean;
};

type MarkAsCompleteCreatorFragmentProps = {
  configProps: MarkAsCompleteCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
};

function MarkAsCompleteCreatorFragment({
  configProps,
  commonProps,
}: MarkAsCompleteCreatorFragmentProps) {
  const { autoAssignOnComplete = false } = configProps;
  const { blockInput, task, onTaskChange } = commonProps;
  const uid = useUID();
  const teamId = useTeamId();
  const state = getByPath(task, "state");
  const checked = state === "completed";

  const { t } = useTranslation();

  const handleCheckedChange = useCallback(
    (newChecked: boolean) => {
      const taskChange: PatchTask = {
        state: newChecked ? "completed" : "pending",
      };

      if (newChecked && autoAssignOnComplete) {
        taskChange.assigned_user_id = uid;
        taskChange.assigned_team_id = teamId;
      }

      onTaskChange(taskChange);
    },
    [autoAssignOnComplete, onTaskChange, teamId, uid]
  );

  if (isLoading(state)) {
    return <LoadingCreatorFragment />;
  }

  return (
    <Switch
      checked={checked}
      onCheckedChange={handleCheckedChange}
      label={t("markAsCompleteString")}
      disabled={blockInput}
    />
  );
}

export default MarkAsCompleteCreatorFragment;
